"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerWithRelsSchema = exports.PlayerSchema = void 0;
const zod_1 = require("zod");
const gender_1 = require("./gender");
exports.PlayerSchema = zod_1.z.object({
    player_id: zod_1.z.number().int().positive(),
    name: zod_1.z.string(),
    nickname: zod_1.z.string().nullable(),
    display_name: zod_1.z.string(),
    date_of_birth: zod_1.z.string().nullable(),
    age: zod_1.z.number().int().positive().nullable(),
    nationality_area_code: zod_1.z.string().nullable(),
    nationality_area_name: zod_1.z.string().nullable(),
    country_of_birth: zod_1.z.number().nullable(),
    weight: zod_1.z.number().nullable(),
    height: zod_1.z.number().nullable(),
    preferred_foot: zod_1.z.string().nullable(),
    gender: gender_1.GenderSchema,
    photo_url: zod_1.z.string().nullable(),
    is_retired: zod_1.z.boolean().nullable(),
    nationality_area_id: zod_1.z.number().nullable(),
    first_name: zod_1.z.string().nullable(),
    last_name: zod_1.z.string().nullable(),
});
const TeamCycleIds = zod_1.z.object({
    team_id: zod_1.z.number().int().positive(),
    cycle_ids: zod_1.z.number().int().positive().array(),
});
exports.PlayerWithRelsSchema = exports.PlayerSchema.pick({
    player_id: true,
    name: true,
    nickname: true,
    display_name: true,
    date_of_birth: true,
    age: true,
    nationality_area_id: true,
    nationality_area_code: true,
    nationality_area_name: true,
    height: true,
    preferred_foot: true,
    gender: true,
}).extend({
    team_cycle_ids: TeamCycleIds.array(),
});
//# sourceMappingURL=player.js.map